import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { db } from '../../firebase';
import '../../css/App.css';
import Button from '../component/Button';

function FlutterList() {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // 対戦回数
    const [count, countState] = useState<number>(0);
    // 選んだ人を見やすくする
    const [selectPlayer, setSelectPlayer] = useState<number | null>(null);
    // 現在の試合の組み合わせ　表示/非表示
    const [isNowMemberShow, setIsNowMemberShow] = useState(false);

    useEffect(() => {
        // eventIdが存在しない場合は早期リターン
        if (!eventId) {
            setError('イベントIDが指定されていません');
            setLoading(false);
            return;
        }

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                // Firebaseからデータを取得
                const dataRef = ref(db, `doubles_data/${eventId}`);
                const snapshot = await get(dataRef);

                if (snapshot.exists()) {
                    setData(snapshot.val());
                } else {
                    setError('指定されたイベントが見つかりません');
                }
            } catch (e) {
                console.error('データ取得エラー:', e);
                setError('データの読み込みに失敗しました');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [eventId]);

    // countが変更された時
    useEffect(() => {
        const element = document.querySelector('#root > div > div > div > table > tbody > tr:nth-child(' + (count + 1) + ')');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [count]);

    // 「戻る」ボタンをクリック
    const backBtnClick = () => {
        navigate("/");
    };

    // ペアをソートする関数
    function sortByPairs(_gameMembers: number[]) {
        if (_gameMembers.length !== 4) {
            return _gameMembers;
        }

        let firstPair: [number, number] = [_gameMembers[0], _gameMembers[1]];
        let secondPair: [number, number] = [_gameMembers[2], _gameMembers[3]];

        firstPair = firstPair.sort((a, b) => a - b) as [number, number];
        secondPair = secondPair.sort((a, b) => a - b) as [number, number];

        return [...firstPair, ...secondPair];
    }

    // ローディング中の表示
    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-xl">読み込み中...</div>
            </div>
        );
    }

    // エラーが発生した場合の表示
    if (error) {
        return (
            <div className="p-6">
                <h2 className="text-2xl font-bold mb-4">エラー</h2>
                <p className="mb-4">{error}</p>
                <Button onClick={() => navigate("/")} className="bg-neutral-600 text-white">
                    戻る
                </Button>
            </div>
        );
    }

    // データが存在しない場合の表示
    if (!data) {
        return <div className="p-6">データが見つかりません</div>;
    }

    // matchesが存在しない、または配列でない場合の対応
    if (!data.matches || !Array.isArray(data.matches)) {
        return (
            <div className="p-6">
                <h1 className="text-2xl font-bold mb-4">ダブルス組み合わせ一覧</h1>
                <p className="mb-2">主催：{data.hostName || '不明'}</p>
                <p>試合データがありません</p>
            </div>
        );
    }

    // 現在の試合のメンバー
    const nowMembers: number[] = data.matches[count]?.players?.map((p: any) => p.number) || [];

    return (
        <>
            <header className="App-header">
                <h1><span className='font-bold'>ダブルス組み合わせ一覧</span></h1>
            </header>
            <div className='p-2 lg:p-6'>
                <div className='flex justify-between mb-4'>
                    <Button className="lg:text-3xl lg:p-3 p-1.5 px-3 bg-neutral-600 text-white rounded-md text-sm font-bold" onClick={backBtnClick}>
                        戻る
                    </Button>
                    <div className="text-sm lg:text-xl">
                        主催：{data.hostName || '不明'}
                    </div>
                </div>

                {/* 現在の試合メンバー表示 */}
                <span className={`my-4 flex justify-center ${isNowMemberShow ? '' : 'invisible'}`}>
                    <label htmlFor={`${count}`}>
                        {nowMembers.map((playerNumber: number, player_i: number) => {
                            const playerClass: string = 'inline-block w-12 lg:w-24 text-center';
                            const player = data.matches[count].players[player_i];
                            return (
                                <span key={`${player_i}`}>
                                    {(player_i === 2) && <span className={`${playerClass} text-black`}>VS</span>}
                                    <button
                                        className={`${playerClass} bg-gray-50 text-black font-bold mx-0.5 px-1 border border-gray-400 rounded-md relative`}
                                        onClick={() => { setSelectPlayer(selectPlayer === playerNumber ? null : playerNumber) }}
                                    >
                                        {/* 名前または数字をメイン表示 */}
                                        <span>{player.name || `${playerNumber}`}</span>
                                        {/* 名前がある場合は数字を右下に小さく表示 */}
                                        {player.name && (
                                            <span className="absolute bottom-0 right-0.5 text-[8px] lg:text-xs text-gray-500">
                                                {playerNumber}
                                            </span>
                                        )}
                                    </button>
                                </span>
                            )
                        })}
                    </label>
                </span>

                {/* 試合移動ボタン */}
                <div className='my-4 flex justify-between'>
                    <Button onClick={() => { if (count !== 0) { countState(count - 1); } }}>
                        前の試合
                    </Button>
                    <span className="text-sm lg:text-3xl cursor-pointer" onClick={() => { setIsNowMemberShow(!isNowMemberShow); }}>
                        <div className='text-center'>試合<span className='text-lg lg:text-4xl mx-1'>{count + 1}</span>回目</div>
                    </span>
                    <Button onClick={() => { if (count !== data.matches.length - 1) { countState(count + 1); } }}>
                        次の試合
                    </Button>
                </div>

                {/* 対戦一覧 */}
                <div className='lg:text-4xl my-2 py-2 h-[calc(100vh-250px)] overflow-scroll border-gray-300 border-2'>
                    <table className='w-full'>
                        <tbody>
                            {data.matches.map((match: any, game_i: number) => {
                                return (
                                    <tr key={`${game_i}`}>
                                        <td className={`lg:mt-2 flex justify-center`}>
                                            {/* 試合番号 */}
                                            <label htmlFor={`${game_i}`} className={`mx-1 lg:mx-12 w-6 text-end ${count === game_i ? 'text-black' : 'text-gray-400 opacity-50'}`}>
                                                {`${game_i + 1}`}
                                            </label>

                                            {/* ラジオボタン */}
                                            <input
                                                type="radio"
                                                id={`${game_i}`}
                                                className={`mx-1`}
                                                checked={count === game_i}
                                                onChange={() => { countState(game_i) }}
                                            />

                                            {/* プレイヤー表示 */}
                                            <label htmlFor={`${game_i}`}>
                                                {match.players.map((player: any, player_i: number) => {
                                                    const playerClass: string = 'inline-block w-12 lg:w-24 text-center';
                                                    const playerNumber = player.number;
                                                    return (
                                                        <span key={`${player_i}`}>
                                                            {(player_i === 2) && <span className={`${playerClass} ${count === game_i ? 'text-black' : 'text-gray-400 opacity-50'}`}>VS</span>}
                                                            <button
                                                                className={`${playerClass} ${selectPlayer === playerNumber ? 'bg-green-700 text-white font-bold' : (count === game_i ? 'bg-yellow-50 text-black font-bold' : 'bg-gray-50')} mx-0.5 px-1 border border-gray-400 rounded-md relative`}
                                                                onClick={() => { setSelectPlayer(selectPlayer === playerNumber ? null : playerNumber) }}
                                                            >
                                                                {/* 名前または数字をメイン表示 */}
                                                                <span>{player.name || `${playerNumber}`}</span>
                                                                {/* 名前がある場合は数字を右下に小さく表示 */}
                                                                {player.name && (
                                                                    <span className={`absolute bottom-0 right-0.5 text-[8px] lg:text-xs ${selectPlayer === playerNumber ? 'text-white opacity-80' : 'text-gray-500'}`}>
                                                                        {playerNumber}
                                                                    </span>
                                                                )}
                                                            </button>
                                                        </span>
                                                    )
                                                })}
                                            </label>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default FlutterList;